export default __webpack_public_path__ + "static/media/kanye8.ab80bd45.webp";